import type { WotSelection } from './sessionTypes'
import type { ClientRecord, SessionLogEntry } from './clients'

export const DEMO_BABBALONIA_ID = 'demo-babbalonia-johnson'

export const WOT_LABELS: Record<WotSelection, string> = {
  hyper: 'Hyper',
  present:   'Present',
  flat:      'Flat',
}

const BABBALONIA_SESSIONS: SessionLogEntry[] = [
  {
    id: 'demo-babbalonia-session-1',
    date: '2026-04-08',
    practices: ['Box breathing', '4–6 breathing pacer'],
    wotStart: 'hyper',
    wotEnd: 'present',
    panasStart: 41,
    panasEnd: 57,
    practitionerNotes:
      'Arrived activated after a difficult morning at work. We mapped the Sleep and Breath circles on canvas and introduced box breathing. Settled noticeably by the second round — shoulders dropped and pace slowed without prompting.',
    followUpNotes:
      'Offer box breathing as a warm-up before deeper canvas work. Ask about sleep quality next session.',
  },
  {
    id: 'demo-babbalonia-session-2',
    date: '2026-04-22',
    practices: ['4–6 breathing pacer', 'Grounding (5 senses)'],
    wotStart: 'present',
    wotEnd: 'present',
    panasStart: 55,
    panasEnd: 62,
    practitionerNotes:
      'Came in grounded today. Brief grounding check-in, then moved straight to paced 4–6 breathing linked to the Breath circle. Good engagement; noticed when to lengthen the exhale without instruction.',
    followUpNotes:
      'Ready to introduce Gut circle when it feels natural. Client is building confidence in self-regulation.',
  },
  {
    id: 'demo-babbalonia-session-3',
    date: '2026-05-06',
    practices: ['Grounding (5 senses)', 'Box breathing', '4–6 breathing pacer'],
    wotStart: 'flat',
    wotEnd: 'present',
    panasStart: 38,
    panasEnd: 54,
    practitionerNotes:
      'Reported feeling flat and disconnected at the start — low energy, hard to focus. Started with grounding before any breathwork. After ten minutes she chose box breathing, then shifted to 4–6 pacing. Left feeling more present and animated.',
    followUpNotes:
      'Flat starts may need grounding first rather than breath-led work. Mood lifted 16 points on PANAS — worth celebrating gently.',
  },
]

export const DEMO_BABBALONIA_CLIENT: ClientRecord = {
  id: DEMO_BABBALONIA_ID,
  name: 'Babbalonia Johnson',
  nameIdentifierType: 'name',
  sessionType: 'practitioner-client',
  track: 'practice',
  dataConsent: 'yes',
  notes:
    'Working on breath regulation and window of tolerance through structured breathwork. Responds well to paced breathing on canvas; prefers a short grounding check-in before deeper practice when arriving flat or activated.',
  sessionHistory: BABBALONIA_SESSIONS,
}
